import { combineReducers } from "@reduxjs/toolkit";
import fileSlice from "./fileSlice";

export default combineReducers({
  file: fileSlice,
});
